// extracted by mini-css-extract-plugin
module.exports = {"pay-btn":"StripeCheckoutButton_pay-btn__1WeiM"};